import * as ngCdkDragDrop from '@angular/cdk/drag-drop'
import * as ngCore from '@angular/core'

import * as input from '../../../input'
import * as overlay from '../../../overlay'
import * as toggleButton from '../../../toggle-button'
import { Store } from '../../store'

/** Owns the table settings trigger and its local attached overlay. */
@ngCore.Component({
  imports: [
    input.checkbox.Component,
    ngCdkDragDrop.DragDropModule,
    overlay.attached.Component,
    toggleButton.Component,
  ],
  selector: 'atn-ds-table-settings',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Shared table state used by the template. */
  public readonly store = ngCore.inject(Store)

  /**
   * Opens the overlay without triggering an ancestor interaction.
   *
   * The settings control sits inside the toolbar, so propagation would let the
   * toolbar treat this as a generic action click as well.
   */
  public settingsClickHandler(event: Event): void {
    event.stopPropagation()
    this.store.setSettingsOpen(true)
  }

  /**
   * Applies a local column order after a completed settings drag.
   *
   * Only the store's local order changes; the controlled column config remains
   * owned by the consumer and is not mutated by the settings overlay.
   */
  public columnDropHandler(event: ngCdkDragDrop.CdkDragDrop<unknown>): void {
    this.store.reorderColumns(event.previousIndex, event.currentIndex)
  }
}
